/** Normalize Mantine `HH:mm` (and partial input) to FHIR `hh:mm:ss`; `undefined` for empty/incomplete. */

const FHIR_TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d|60)(\.\d+)?)?$/;

export function toFhirTimeValue(value: string | undefined | null): string | undefined {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;
  const match = FHIR_TIME_PATTERN.exec(trimmed);
  if (!match) return undefined;
  const [, hours, minutes, seconds, fraction] = match;
  return `${hours}:${minutes}:${seconds ?? '00'}${fraction ?? ''}`;
}
